const content: { [key: string]: any } = {
  permissionRoleGroupDetail: 'Permission Group Detail',
};

export default content;
